import { Layout } from "@mcleod/components";
import { DemoDefinition } from "./DemoDefinition";
import { DemoRegistry } from "./DemoRegistry";

export class AlignmentDemo extends Layout {
}
DemoRegistry.get().register(new DemoDefinition("AlignmentDemo", [ "Concepts", "Alignment" ]));
